module.exports = __webpack_public_path__ + "img/titletc.9e85929f.png";